<template>
  <BaseInnerSidebar :show-title="false">
    <template #title>
      <div class="flex items-center gap-2">
        <i class="pi pi-user text-primary-600" />
        <span>Contact Profile</span>
      </div>
    </template>
    <template #content>
      <nav class="space-y-1">
        <nuxt-link
          v-for="(tab, index) in tabs"
          :key="index"
          :to="tab.route"
          class="block"
        >
          <BaseSidebarOption :is-active="tab.active">
            <Icon
              :name="tab.icon"
              class="text-base w-5"
            />
            <span>{{ tab.name }}</span>
          </BaseSidebarOption>
        </nuxt-link>
      </nav>
    </template>
  </BaseInnerSidebar>
</template>

<script lang="ts" setup>
import { ContactDetailIcon } from '~/types/baseIcon'

const route = useRoute()

const contactId = computed(() => {
  return route.params?.contactId as string
})

const routeName = computed(() => {
  return route.name as string
})

const tabs = computed(() => {
  return [
    { name: 'Contact Information', icon: ContactDetailIcon.PROFILE, route: { name: 'contacts-contactId-profile', params: { contactId: contactId.value } }, active: routeName.value === 'contacts-contactId-profile' },
    { name: 'Contact Activity', icon: ContactDetailIcon.ACTIVITY, route: { name: 'contacts-contactId-activity', params: { contactId: contactId.value } }, active: routeName.value === 'contacts-contactId-activity' },
    { name: ' Automations', icon: ContactDetailIcon.AUTOMATION, route: { name: 'contacts-contactId-automation', params: { contactId: contactId.value } }, active: routeName.value === 'contacts-contactId-automation' },
  ]
})
</script>
